<mat-toolbar class="p-2 px-3 header">
  <img src="assets/images/icons/icon_clover_header.svg" />
</mat-toolbar>